module.exports = __webpack_public_path__ + "static/media/manceraredtobacco.24bd7e18.png";